export default __webpack_public_path__ + "static/media/saquon.ef81147d.png";